import React, { FC, useState } from 'react';
import { Button, FormGroup, Input, InputGroup, InputGroupText, Label } from 'reactstrap';
import { UserSelector } from '../../../components/UserSelector';
import { JSONForm, PreSubmitData } from '../../../components/json-form/JSONForm';
import { useTranslation } from '../../../translations';
import { useConfig } from '../../../utils';

interface CreateFeePost {
  amount: number;
  reason: string;
  userId: number;
}

const OuterUserSelector: FC<{
  readonly selectionChanged: (userIds: number[]) => void;
}> = ({ selectionChanged }) => {
  return <UserSelector id="feeRecipients" maxItems={1} selectionIdsChanged={selectionChanged} />;
};

const updatePreSubmit = ({ inputs }: PreSubmitData<CreateFeePost>) => {
  inputs.amount *= 100;
};

/**
 * A component that will let you add a ban.
 * Include the userId if you want it to act more like a quick button (Say, on a user's profile page)
 */
export const CreateFee: FC<{ readonly onSuccess: () => void }> = ({ onSuccess }) => {
  const { ts } = useTranslation();
  const { currencySymbol } = useConfig();
  const [userId, setUserId] = useState<number | undefined>(undefined);

  return (
    <JSONForm<object, CreateFeePost>
      id="addFee"
      method="post"
      onSuccess={onSuccess}
      path="/api/fees"
      preSubmit={(opts) => {
        updatePreSubmit(opts);
      }}
    >
      <FormGroup>
        <Label for="recipients">{ts('common.user')}</Label>
        <Input name="userId" type="hidden" value={userId} />
        <OuterUserSelector
          selectionChanged={(ids) => {
            setUserId(ids[0]);
          }}
        />
      </FormGroup>
      <FormGroup>
        <Label for="type">{ts('common.amount')}</Label>
        <InputGroup>
          <InputGroupText>{currencySymbol}</InputGroupText>
          <Input id="amount" min="0" name="amount" step="0.01" type="number" />
        </InputGroup>
      </FormGroup>
      <FormGroup>
        <Label for="reason">{ts('reason_for_fee')}</Label>
        <Input id="reason" name="reason" style={{ minHeight: '10px' }} type="textarea" />
      </FormGroup>
      <FormGroup>
        <Button block color="primary" id="addFeeBtn" type="submit">
          {ts('create_fee')}
        </Button>
      </FormGroup>
    </JSONForm>
  );
};
